import { render, staticRenderFns } from "./StockTransManagerView.vue?vue&type=template&id=5a18457f&scoped=true"
import script from "./StockTransManagerView.vue?vue&type=script&lang=js"
export * from "./StockTransManagerView.vue?vue&type=script&lang=js"
import style0 from "./StockTransManagerView.vue?vue&type=style&index=0&id=5a18457f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18457f",
  null
  
)

export default component.exports